import service from './request'

/**
 * 获取部门列表
 */
 export const getOrgList = data => {
  return service({
      showLoading: true,//调用预加载
      url: '/platform/org/getList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 部门信息添加
 */
 export const addOrgInfo = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/org/addInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 部门信息修改
 */
 export const updateOrgInfo = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/org/updateInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 部门信息删除
 */
 export const delOrgInfo = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/org/delInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 部门人员查看
 */
 export const getUserList = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/org/getUserList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 部门人员编辑
 */
 export const updateUserData = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/org/updateUserData',
      method: 'post',
      type: 'body',
      data
  })
}



// WEBPACK FOOTER //
// ./src/http/BranchManagement.js